globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import * as React from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { Title } from '../../';
import { CardUploadIcon } from './svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var UploadCard = function UploadCard(_ref) {
  var _ref$fileType = _ref.fileType,
      fileType = _ref$fileType === void 0 ? ['.pdf'] : _ref$fileType,
      setUploadFiles = _ref.setUploadFiles,
      isError = _ref.isError,
      testId = _ref.testId;
  var acceptedFormats = useMemo(function () {
    return typeof fileType === 'string' ? fileType : Array.isArray(fileType) ? fileType === null || fileType === void 0 ? void 0 : fileType.join(',') : AcceptedFileType.Pdf;
  }, [fileType]);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(Wrapper, {
    "data-cy": testId,
    children: /*#__PURE__*/_jsx("div", {
      className: "flex items-center justify-center w-full",
      children: /*#__PURE__*/_jsxs(LabelStyled, {
        isError: isError,
        htmlFor: "dropzone-file",
        "data-cy": "dropzone-file",
        children: [/*#__PURE__*/_jsxs(_StyledDiv, {
          children: [/*#__PURE__*/_jsx(CardUploadIcon, {
            stroke: isError ? "#ba001f" : "#8e69ce"
          }), /*#__PURE__*/_jsxs(_StyledP, {
            children: [/*#__PURE__*/_jsx(UnderLinedText, {
              isError: isError,
              children: t('common:click_here')
            }), ' ', t('common:to_upload_your_file')]
          }), /*#__PURE__*/_jsx(Title, {
            content: "".concat(t('common:upload_a_file'), ": ").concat(acceptedFormats.replace(/,/g, ', '), " (20MB max)"),
            textColor: "gray",
            fontSize: "xSmall",
            fontWeight: "light",
            testId: "upload-a-file-text"
          })]
        }), /*#__PURE__*/_jsx(Input, {
          type: "file",
          id: "dropzone-file",
          hidden: true,
          onChange: function onChange(event) {
            return setUploadFiles(event.target.files);
          },
          accept: acceptedFormats,
          "data-cy": "upload-a-file-input"
        })]
      })
    })
  });
};
export default UploadCard;

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "cardupload__Wrapper",
  componentId: "sc-1s5x0vy-0"
})({
  "width": "100%"
});

var Input = /*#__PURE__*/_styled.input.withConfig({
  displayName: "cardupload__Input",
  componentId: "sc-1s5x0vy-1"
})({});

var AcceptedFileType = {
  Text: '.txt',
  Gif: '.gif',
  Jpeg: '.jpg',
  Png: '.png',
  Doc: '.doc',
  Pdf: '.pdf',
  AllImages: 'image/*',
  AllVideos: 'video/*',
  AllAudios: 'audio/*'
};

var LabelStyled = /*#__PURE__*/_styled.label.withConfig({
  displayName: "cardupload__LabelStyled",
  componentId: "sc-1s5x0vy-2"
})(["", " ", ""], {
  "display": "flex",
  "height": "100%",
  "width": "100%",
  "cursor": "pointer",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "1rem",
  "borderWidth": "2px",
  "borderStyle": "dashed",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(105 62 181 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))"
}, function (_ref2) {
  var isError = _ref2.isError;
  return isError ? {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(186 0 31 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(250 230 233 / var(--tw-bg-opacity))"
  } : {};
});

var UnderLinedText = /*#__PURE__*/_styled.span.withConfig({
  displayName: "cardupload__UnderLinedText",
  componentId: "sc-1s5x0vy-3"
})(["", " ", ""], {
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(105 62 181 / var(--tw-text-opacity))",
  "textDecorationLine": "underline",
  "textUnderlineOffset": "4px"
}, function (_ref3) {
  var isError = _ref3.isError;
  return isError ? {
    "--tw-text-opacity": "1",
    "color": "rgb(186 0 31 / var(--tw-text-opacity))"
  } : {
    "--tw-text-opacity": "1",
    "color": "rgb(105 62 181 / var(--tw-text-opacity))"
  };
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cardupload___StyledDiv",
  componentId: "sc-1s5x0vy-4"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "0.5rem",
  "paddingTop": "1.5rem",
  "paddingBottom": "1.5rem",
  "paddingLeft": "2.75rem",
  "paddingRight": "2.75rem"
});

var _StyledP = /*#__PURE__*/_styled("p").withConfig({
  displayName: "cardupload___StyledP",
  componentId: "sc-1s5x0vy-5"
})({
  "marginBottom": "0.5rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "--tw-text-opacity": "1",
  "color": "rgb(28 19 39 / var(--tw-text-opacity))"
});